<template>
    <button class="ui-button">
        <slot name="default"></slot>
    </button>
</template>

<script>
	export default {
		name: 'ui-button'
    }
</script>

<style rel="stylesheet/stylus" lang="stylus" scoped>
    .ui-button {
        padding 0 16px
        display inline-block
        position relative
        overflow hidden
        user-select none
        cursor pointer
        outline none
        background none
        border 0
        transition $swift-ease-out
        color currentColor
        font-family inherit
        font-size $font-size-base
        font-style inherit
        font-variant inherit
        letter-spacing inherit
        text-align center
        text-decoration none
        vertical-align top
        white-space nowrap
        box-sizing border-box
        -webkit-tap-highlight-color transparent
        -webkit-touch-callout none

        &:focus {
            outline none
        }

        &::-moz-focus-inner {
            border 0
        }

        &:hover {
            &:not([disabled]) {
                background-color #292929
                border-bottom-color #474747
                text-decoration none
            }
        }
    }
</style>